import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { Text, FlexContainer, Separator } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import PreviousYearResultBanner from 'Containers/Result/components/PreviousYearResultBanner';
import MandatoryInfo from 'Containers/Result/components/MandatoryInfo';
import { ResultType } from 'Types/common';

const ResultLessRefund = ({ data }: { data: ResultType }): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  return (
    <>
      <Text type="paragraphs" align="center" size="L_XL_S" color="dark">
        {t('Result.less.title')}
      </Text>
      <FlexContainer align="center" gap="dimension_08">
        <Text type="paragraphs" align="center" size="M_L_S" color="dark">
          {t('Result.less.subtitle')}
        </Text>
        <Text type="paragraphs" align="center" size="L_L_S" color="dark">
          {YayoyakiFormatter.formatAmountMxn(Math.abs(data?.taxReturnResult))}
        </Text>
      </FlexContainer>
      <PreviousYearResultBanner data={data} />
      {data.mandatory && <MandatoryInfo daInfo={data} />}
      <Separator />
      <Text type="paragraphs" align="center" size="S_M_S" color="dark">
        {t('Result.less.description')}
      </Text>
    </>
  );
};

export default ResultLessRefund;
